(function (root) {
  'use strict';

  var formSelectors = [
    '#globo-formbuilder-105504',
    '#globo-formbuilder-105646',
    '#globo-formbuilder-116456',
    '#globo-formbuilder-127004'
  ];
  var formSelector = formSelectors.join(',');
  var linkRemovalRules = [
    { formId: 'globo-formbuilder-105646', text: 'Learn More About Our Custom Process' },
    { formId: 'globo-formbuilder-105504', text: 'Discover Our Rings' }
  ];

  function normalizedText(value) {
    return (value || '').replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function addLogo(documentRef, wrapper, logoSrc) {
    var app = wrapper.querySelector('.globo-form-app');
    if (!app || app.querySelector('.powerful-form-mobile-logo')) return;

    var bar = documentRef.createElement('div');
    bar.className = 'powerful-form-mobile-logo';
    var image = documentRef.createElement('img');
    image.src = logoSrc;
    image.alt = 'Jade Trau';
    image.width = 132;
    image.height = 17;
    bar.appendChild(image);
    app.insertBefore(bar, app.firstChild);
  }

  function markNameFields(wrapper) {
    var first = wrapper.querySelector('input[name="text"]');
    var last = wrapper.querySelector('input[name="text-2"]');
    var firstControl = first && first.closest('.globo-form-control');
    var lastControl = last && last.closest('.globo-form-control');
    if (firstControl) firstControl.classList.add('powerful-form-name-field', 'powerful-form-name-field--first');
    if (lastControl) lastControl.classList.add('powerful-form-name-field', 'powerful-form-name-field--last');
  }

  function removeRequestedLinks(documentRef) {
    linkRemovalRules.forEach(function (rule) {
      var wrapper = documentRef.getElementById(rule.formId);
      if (!wrapper) return;
      Array.prototype.forEach.call(wrapper.querySelectorAll('a'), function (link) {
        if (normalizedText(link.textContent) === normalizedText(rule.text)) link.remove();
      });
    });
  }

  function wrapperIsOpen(view, wrapper) {
    var style = view.getComputedStyle(wrapper);
    return style.display !== 'none' && style.visibility !== 'hidden';
  }

  function syncOpenState(documentRef, view) {
    var open = Array.prototype.some.call(documentRef.querySelectorAll(formSelector), function (wrapper) {
      return wrapperIsOpen(view, wrapper);
    });
    documentRef.body.classList.toggle('powerful-form-open', open);
  }

  function enhance(documentRef, view, logoSrc) {
    Array.prototype.forEach.call(documentRef.querySelectorAll(formSelector), function (wrapper) {
      addLogo(documentRef, wrapper, logoSrc);
      markNameFields(wrapper);
    });
    removeRequestedLinks(documentRef);
    syncOpenState(documentRef, view);
  }

  function init(documentRef, view, logoSrc) {
    var queued = false;
    function scheduleEnhancement() {
      if (queued) return;
      queued = true;
      view.requestAnimationFrame(function () {
        queued = false;
        enhance(documentRef, view, logoSrc);
      });
    }

    enhance(documentRef, view, logoSrc);
    var observer = new view.MutationObserver(scheduleEnhancement);
    observer.observe(documentRef.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['style']
    });
  }

  if (!root.document) return;
  var script = root.document.currentScript;
  var logoSrc = script && script.getAttribute('data-logo-src');
  if (!logoSrc) return;
  if (root.document.readyState === 'loading') {
    root.document.addEventListener('DOMContentLoaded', function () {
      init(root.document, root, logoSrc);
    }, { once: true });
  } else {
    init(root.document, root, logoSrc);
  }
})(typeof window !== 'undefined' ? window : this);
